// dependancys
import React, { useState, useEffect, useGlobal} from "reactn";

// components
import Loader from "shared-anpost-components/components/loader/Loader";
import GlobalError from "shared-anpost-components/components/globalError/GlobalError";
import { TabsWrapper, Tab } from "../../_common/form/tabs/Tabs.styled";
import ProfileInfo from "./_sections/_profileInfo/ProfileInfo";
import Marketing from "./_sections/_marketing/Marketing";
import Error from "../../_common/error/Error";

// API
import { getProfile, getJWTInfo } from "../../../services/Api";

// hooks
import profileHooks from "../../../hooks/profileHooks";

// helpers
import { setAllGlobalConsents } from "./_sections/_marketing/Marketing.helpers";

const Profile = ({ profileTab }) => {
    const { values, refreshGlobalVals, setGlobalValue } = profileHooks();

    const [loader, setLoader] = useState(true);
    const [apiError, setApiError] = useState(false);

    const [profileData, setProfileData] = useState({});
    const [consents, setConsents] = useState({});
    const [marketingConsents, setMarketingConsents] = useState({});
	const [consentProfiling, setConsentProfiling] = useState(null);
    const [currentProfileTab, setCurrentProfileTab] = useState(profileTab);
    const [isBusiness, setIsBusiness] = useGlobal("isBusiness");
    const [userProfile, setuserProfile] = useGlobal("userProfile");
    const [showBusinessBanner, setShowBusinessBanner] = useGlobal("businessBanner");
    const [isAnPostApp] = useGlobal("isAnPostApp");

    const closeFunc = () => {
        setApiError(false);
    };

    const setProfileCallback = (profileData, callback) => {
        setProfileData(profileData);

        // set consents
        setConsents(profileData.consents);
        setMarketingConsents(profileData.marketing);
        const profiling = profileData.consents.filter(obj => {
            return obj.consentCode === 'anpost_profiling';
        });

        setConsentProfiling(profiling.length > 0 ? profiling[0].isConsentGranted : true);
        setLoader(false);
        if (callback) {
            callback(profileData.profile.firstName || profileData.email);
        }
    };

    const getProfileInfo = (UID, callback) => {
        setLoader(true);
        getJWTInfo().then(() => {
            const profileData = JSON.parse(sessionStorage.getItem("userProfile"));
            if (profileData && profileData.uid) {
                setProfileCallback(profileData, callback);
            } else {
                getProfile(UID).then(res => {
                    if (res.status === 200) {
                        setProfileCallback(res.data, callback);
                    } else {
                        setApiError(true);
                        setLoader(false);
                    }
                });    
            }
        });
    };

    // for dev purposes, when developing locally
    useEffect(() => {

        window.marketingUpdated = {};

        // if dev mode or the user is alreadey logged in
        if (window.apDevMode || values.loggedIn) {
            getProfileInfo(values.ciamUserId);
        }
    }, []);

	useEffect(() => {
		// set values for marketing consents here to keep them between tabs
		if (Object.keys(marketingConsents).length > 0 && consentProfiling !== null) {
			const tmpValues = setAllGlobalConsents(values, marketingConsents.channels, marketingConsents.applications);
			tmpValues["anpost_profiling"] = consentProfiling;
			refreshGlobalVals(tmpValues);
		}
	}, [marketingConsents, consentProfiling])

    // checks to show business banner or not
    useEffect(() => {
        const profileData = JSON.parse(sessionStorage.getItem("userProfile"));
        !userProfile && setuserProfile(profileData);
        if (userProfile?.profile?.business?.name || profileData?.profile?.business?.name) {
            setShowBusinessBanner(false);
        }
    }, [userProfile, isBusiness]);

    return (
        <>
            {loader && <Loader local/>}
            {apiError && <GlobalError closeFunc={closeFunc} />}
            {!loader && (
                <>
                    <h3 className="h4">Profile and settings</h3>
                    {!values.loggedIn && <Error errorHeading="You are not logged in. You need to be logged into your An Post account to view this page." loginPrompt></Error>}
                    {values.loggedIn && (
                        <>
                            {!isAnPostApp && (
                                <TabsWrapper className="mt3">
                                    <Tab
                                        active={!currentProfileTab || currentProfileTab === "profile"}
                                        onClick={e => {
                                            e.preventDefault();
                                            setCurrentProfileTab("profile");
                                        }}
                                        style={{paddingBottom: "1.6rem"}}
                                    >
                                        Your details
                                    </Tab>
                                    {(marketingConsents.length > 0 || consents.length > 0) && (
                                        <Tab
                                            active={currentProfileTab === "marketing"}
                                            onClick={e => {
                                                e.preventDefault();
                                                setCurrentProfileTab("marketing");
                                            }}
                                            style={{paddingBottom: "1.6rem"}}
                                        >
                                            Marketing preferences
                                        </Tab>
                                    )}
                                </TabsWrapper>
                            )}
                            {(!currentProfileTab || currentProfileTab === "profile") && <ProfileInfo profile={profileData}></ProfileInfo>}
                            {currentProfileTab === "marketing" && (
                                <Marketing 
									marketingConsents={marketingConsents} 
									refreshGlobalVals={refreshGlobalVals} 
									setGlobalValue={setGlobalValue}
								/>
                            )}
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default Profile;
Profile.propTypes = {};
